<!-- Sidepanel Right Search Customer -->
<aside [ngClass]="{'active':  userService.campaignUpdateModal.isModalOpen }" class="footer-sidepanel footer-sidepanel--customer-search">
    <div class="footer-sidepanel__header">
        <h5><i class="fa-light fa-pen-to-square"></i>Update Campaigns for {{ userService.campaignUpdateModal.userNames.length > 0 ? "User(s): " + userService.campaignUpdateModal.userNames : ''}} </h5>
        <a (click)="userService.closeCampaignUpdateModal()"><i class="fa-light fa-xmark"></i></a>
    </div>
    <div class="footer-sidepanel__content"> 
      <div class="  form-wrapper-compact">
        <div class="flex-row">
          <div class="flex-col-sm-12">
            <section class="section form-wrapper-compact">
              <div class="section__content">
                
                <div class=" mb-10">
                  <div class="address-form">
                    <form class="form-fields form-container">
                      <div class="flex-row flex-row--compact" *ngIf="userService.campaignUpdateModal.agentCampaignsDropDown.length">
                        <div class="flex-col-sm-12">
                          <div class="single-input-field-wrapper">
                            <label  class="form-fields__label">Agent Campaigns</label>
                            <div class="dropdown-list-wrapper">
                              <div class="dropdown-list">
                                <f-multiSelect
                                  [ngStyle]="{ width: '100%', height: '100%' }"
                                  [style]="{ width: '100%', height: '100%' }"
                                  placeholder="Select campaigns"
                                  display="chip"
                                  optionLabel="lable"
                                  optionValue="value"
                                  [options]="userService.campaignUpdateModal.agentCampaignsDropDown"
                                  [(ngModel)]="userService.campaignUpdateModal.agentCampaigns"
                                  [leftIconClass]="'fa-thin fa-buildings'"
                                   name="agentCampaigns"
                                >
                                </f-multiSelect>
                              </div>
                            </div>
                            @if (userService.campaignUpdateModal && !userService.campaignUpdateModal.agentCampaigns.length) {
                            <div class="validation validation--error">Please provide campaign.</div>
                            }
                          </div>
                        </div>
                        <div class="flex-col-sm-12 customer-journey-data">
                          @for (campaign of userService.campaignUpdateModal.agentCampaigns; track campaign; let i = $index) {
                          <div class="chips chips--without-icon" style="margin-right: 5px; padding-top: 12px;">
                            <span class="{{ i == 0 ? 'chips__value chips__value--success chips__value--green-outlined soft-border-4' : 'chips__value chips__value--danger chips__value--red-outlined soft-border-4' }}">{{campaign}}</span>
                          </div>
                          }
                        </div>
                      </div>
                       <div class="flex-row flex-row--compact" *ngIf="userService.campaignUpdateModal.supervisorCampaignsDropDown.length">
                        <div class="flex-col-sm-12">
                          <div class="single-input-field-wrapper">
                            <label class="form-fields__label">Supervisor Campaigns</label>
                            <div class="dropdown-list-wrapper">
                              <div class="dropdown-list">
                                <f-multiSelect
                                name="supervisorCampaigns"
                                  [ngStyle]="{ width: '100%', height: '100%' }"
                                  [style]="{ width: '100%', height: '100%' }"
                                  placeholder="Select campaigns"
                                  display="chip"
                                  optionLabel="lable"
                                  optionValue="value"
                                  [options]="userService.campaignUpdateModal.supervisorCampaignsDropDown"
                                  [(ngModel)]="userService.campaignUpdateModal.supervisorCampaigns"
                                  [leftIconClass]="'fa-thin fa-buildings'"
                                >
                                </f-multiSelect>
                              </div>
                            </div>
                            @if (userService.campaignUpdateModal && !userService.campaignUpdateModal.supervisorCampaigns.length) {
                            <div class="validation validation--error">Please provide campaign.</div>
                            }
                          </div>
                        </div>
                        <div class="flex-col-sm-12 customer-journey-data">
                          @for (campaign of userService.campaignUpdateModal.supervisorCampaigns; track campaign; let i = $index) {
                          <div class="chips chips--without-icon" style="margin-right: 5px; padding-top: 12px;">
                            <span class="{{ i == 0 ? 'chips__value chips__value--success chips__value--green-outlined soft-border-4' : 'chips__value chips__value--danger chips__value--red-outlined soft-border-4' }}">{{campaign}}</span>
                          </div>
                          }
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </section>
            <section class="section">
              <div class="section__content">
                <div class="flex-row flex-row--no-pad">
                  <div class="flex-col-sm-12">
                    <div class="form-secondary-header">
                      <div class="form-actions">
                        <!-- Single-Button -->
                        <a (click)="userService.closeCampaignUpdateModal()" class="single-button--without-bg" style="margin-right: 10px;">Cancel</a>
                        <a (click)="userService.onUpdateUserCampaigns()" class="single-button--with-bg">Update</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      
    </div>
</aside>